export const LANGS = {
  it: {
    nav: {
      links: [
        { id: "progetto", label: "Progetto" },
        { id: "programma", label: "Programma" },
        { id: "scuole", label: "Scuole & ITS" },
        { id: "social", label: "Social" },
        { id: "sponsor", label: "Sponsor" },
        { id: "logistica", label: "Logistica" },
      ],
      cta: "Scheda di Adesione",
    },
    hero: {
      chip1: "Misano World Circuit — 3/9 Maggio 2027",
      chip2: "Electric Vehicle Grand Prix",
      lines: [
        { t: "La Motor Valley", g: null },
        { t: "incontra il ", g: "futuro" },
        { t: "della Mobilità ", g: "Elettrica." },
      ],
      sub: "Dal 3 al 9 Maggio 2027 al Circuito Misanino: gli studenti delle scuole e università d'Italia e del mondo si sfidano sui veicoli elettrici ad alta efficienza.",
      kicker: "Where Motor Valley meets the electric future",
      cta1: "Scarica la Scheda di Adesione",
      cta2: "Diventa Sponsor",
      countdown: [
        { l: "Giorni", tid: "countdown-days" },
        { l: "Ore", tid: "countdown-hours" },
        { l: "Min", tid: "countdown-minutes" },
        { l: "Sec", tid: "countdown-seconds" },
      ],
      imgChips: { soc: "SOC Batteria 1.0 kWh", telemetry: "Telemetria attiva", limiter: "Limitatore attivo" },
      imgCaption: "EV-01 · Monoposto a 3 ruote",
      imgTag: "Kit ufficiale EVGP",
    },
    marquee: ["EVGP Italia 2027", "3—9 Maggio", "Misano World Circuit", "Progettare", "Costruire", "Gareggiare", "Crescere"],
    progetto: {
      kicker: "Il Progetto & Missione",
      title: "Progettare. Costruire. Gareggiare. Crescere.",
      en: "The format — STEM meets the racetrack",
      pillars: [
        { t: "Progettare", d: "Dall'aerodinamica alla gestione dell'energia: i team progettano in classe la monoposto con il supporto di docenti e partner tecnici." },
        { t: "Costruire", d: "Il kit ufficiale EVGP prende forma nei laboratori d'istituto: telaio, cablaggi e battery pack assemblati dagli studenti." },
        { t: "Gareggiare", d: "In pista a Misano con la telemetria attiva: ogni sorpasso è una lezione di fisica applicata ed efficienza energetica." },
        { t: "Crescere", d: "Forum tecnici, network con le aziende e competenze STEM che restano ai team ben oltre il traguardo." },
      ],
      specEyebrow: "EV-01 — Technical Sheet",
      specTitle: "Scheda tecnica del veicolo",
      specs: [
        { label: "Tipologia", value: "Monoposto a 3 ruote ad alta efficienza" },
        { label: "Energia", value: "Batterie piombo-acido · 1.0 kWh con monitoraggio" },
        { label: "Telemetria", value: "Cycle Analyst · data log in tempo reale" },
        { label: "Sicurezza", value: "Limitazione di velocità per la massima sicurezza" },
      ],
      chips: ["1.0 kWh", "Cycle Analyst", "3 Ruote"],
      imgCaption: "Costruire — il laboratorio d'istituto",
      cockpitCaption: "Cycle Analyst · Data log",
    },
    programma: {
      kicker: "Programma dell'Evento",
      title: "Sette giorni in pista: 3—9 Maggio 2027",
      en: "La settimana di gara — giorno per giorno",
      mayLabel: "Maggio 2027",
      days: [
        { d: "3", wd: "Lun", phase: "Arrivo Kit & Team", tag: "Paddock", desc: "Consegna dei kit ufficiali EVGP, accrediti dei team e apertura del paddock: le scuole prendono possesso dei propri box al Circuito Misanino." },
        { d: "4", wd: "Mar", phase: "Allestimento Box", tag: "Paddock", desc: "Montaggio delle postazioni di lavoro, setup degli strumenti e del banco dati: il paddock si trasforma in officina a cielo aperto." },
        { d: "5", wd: "Mer", phase: "Verifiche Tecniche", tag: "Scrutineering", desc: "I commissari verificano la conformità dei veicoli: telai, batterie, cablaggi e sistemi di sicurezza prima di scendere in pista." },
        { d: "6", wd: "Gio", phase: "Prove Libere", tag: "Pista", desc: "Prime uscite in pista con la telemetria Cycle Analyst attiva: shakedown, taratura dei parametri e prime sfide sul tempo." },
        { d: "7", wd: "Ven", phase: "Prove Libere & Forum Tecnici Serali", tag: "Pista · Forum", desc: "Sessioni di guida di giorno e, al tramonto, forum tecnici con ingegneri e aziende partner: energia, aerodinamica, strategia." },
        { d: "8", wd: "Sab", phase: "Qualifiche & GARA EVGP", tag: "Gara", desc: "Le qualifiche stabiliscono la griglia di partenza: nel pomeriggio la GARA EVGP Italia 2027 assegna il titolo sul Circuito Misanino.", hot: true },
        { d: "9", wd: "Dom", phase: "Gala di Premiazione & Disallestimento", tag: "Gala", desc: "La settimana si chiude con il gala di premiazione dei team e il disallestimento del paddock: appuntamento al 2028." },
      ],
    },
    scuole: {
      kicker: "Area Scuole & ITS",
      title: "Due modi di vivere l'EVGP",
      en: "Due modi per partecipare — team in pista o delegazioni esperienziali",
      optionA: {
        title: "Team in Pista",
        desc: "Fornitura del kit ufficiale e supporto PNRR STEM: la tua scuola progetta e costruisce la propria monoposto. Inclusive le strategie di crowdfunding per sostenere il progetto fino alla gara.",
        tag: "Richiedi il Kit EVGP",
      },
      optionB: {
        title: "Delegazione Esperienziale",
        desc: "Forum tecnici serali, inclusion, network con aziende e università e vita di box: l'esperienza completa EVGP senza costruire il veicolo, full immersion nella Motor Valley.",
        tag: "Partecipa con la tua classe",
      },
      formTitle: "Scheda di Adesione",
      formIntro: "Compila la richiesta: il team organizzativo di Co.Ge.S.Tur. ti ricontatterà con kit, costi e supporto per la tua modalità di partecipazione.",
      formTag: "ITIS · IPSIA · ITS Academy · Università",
      imgCaption: "Una monoposto di un istituto partecipante",
      modeLabel: "Modalità di partecipazione *",
      modes: [
        { v: "team_in_pista", l: "A — Team in Pista (Kit EVGP)" },
        { v: "delegazione", l: "B — Delegazione Esperienziale" },
      ],
      fields: {
        nome: "Nome e cognome referente *",
        istituto: "Istituto / ITS / Università *",
        email: "Email istituzionale *",
        telefono: "Telefono",
        num_studenti: "N. studenti coinvolti",
        messaggio: "Messaggio",
      },
      roleOptions: ["Docente / Referente", "Dirigente Scolastico", "Studente", "Rappresentante ITS / Università", "Altro"],
      roleLabel: "Ruolo",
      msgPlaceholder: "Raccontaci il tuo istituto, l'esperienza del team, le domande sul kit...",
      error: "Compila i campi obbligatori: nome, istituto ed email.",
      sending: "Invio in corso...",
      submit: "Invia la richiesta di adesione",
      successTitle: "Richiesta ricevuta!",
      success: (nome, istituto, email) => `Grazie ${nome}: abbiamo registrato la richiesta per l'istituto ${istituto}. Riceverai la scheda di adesione completa all'indirizzo ${email}.`,
      reset: "Invia un'altra richiesta",
    },
    social: {
      kicker: "Piano Social & Contenuti",
      title: "#RoadToMisano — la strategia sociale dell'evento",
      en: "Architettura dei canali · calendario editoriale · copy pronti",
      bannerTag: "#MeetTheTeam",
      bannerTitle: "I team EVGP al lavoro",
      channels: [
        { name: "LinkedIn", audience: "B2B & Istituzioni", desc: "Presidi, Università, Sponsor e Ministeri: preparazione dell'evento, valore STEM del format, partnership e risultati dei team." },
        { name: "Instagram / TikTok", audience: "Studenti & Youth", desc: "Dietro le quinte dai box, reel dinamici dei prototipi in pista, vlog dei team durante l'intera settimana di gara." },
        { name: "Facebook", audience: "Comunità & Famiglie", desc: "Comunità locale, famiglie e aggiornamenti istituzionali: programma, logistica e iniziative aperte al pubblico." },
      ],
      calTitle: "Calendario editoriale — 4 format guida",
      formats: [
        { tag: "#TechTuesday", cadence: "Ogni martedì", desc: "Dettagli tecnici dei kit: batterie, controller, aerodinamica." },
        { tag: "#MeetTheTeam", cadence: "Ogni giovedì", desc: "Presentazione degli istituti e delle ITS Academy partecipanti." },
        { tag: "#RoadToMisano", cadence: "Settimanale", desc: "Countdown e logistica dell'evento: cosa vedere e come arrivare." },
        { tag: "#EVGPSocial", cadence: "Weekend", desc: "Focus su inclusione, forum serali e vita di squadra." },
      ],
      copyTitle: "Copywriting pronto all'uso",
      copySub: "Post pronti da pubblicare",
      bioCopied: "Bio copiata negli appunti",
      postCopied: "Post copiato negli appunti",
      copyFailed: "Copia non riuscita",
      copied: "Copiato!",
      copyPost: "Copia il post",
      setupTitle: "Impostazioni dei canali",
      setupSub: "Nome, handle e bio pronti per aprire le pagine",
      handleLabel: "Handle consigliato",
      channelsSetup: [
        { name: "Facebook", handle: "facebook.com/evgpitalia", bioIt: "Il Grand Prix dei veicoli elettrici costruiti dagli studenti. 3-9 maggio 2027 · Misano World Circuit. Progettare, Costruire, Gareggiare, Crescere ⚡", bioEn: "The Grand Prix of student-built electric vehicles. 3-9 May 2027 · Misano World Circuit. Design, Build, Race, Grow ⚡" },
        { name: "Instagram", handle: "@evgpitalia", bioIt: "⚡ Studenti in pista con le monoposto elettriche | 3-9 MAGGIO 2027 · MWC Misano | #RoadToMisano", bioEn: "⚡ Students on track with electric racers | 3-9 MAY 2027 · MWC Misano | #RoadToMisano" },
        { name: "TikTok", handle: "@evgpitalia", bioIt: "STEM in pista ⚡ Le monoposto elettriche degli studenti d'Italia | 3-9 maggio 2027 Misano", bioEn: "STEM on track ⚡ Student-built EV racers from Italy | May 3-9, 2027 Misano" },
      ],
      posts: [
        {
          id: "linkedin",
          label: "LinkedIn",
          audience: { it: "Per ingaggiare gli sponsor", en: "To engage sponsors" },
          text: {
            it: "⚡ EVGP Italia 2027 | La Motor Valley cerca i suoi partner\n\nDal 3 al 9 maggio 2027 il Misano World Circuit «Marco Simoncelli» ospita l'Electric Vehicle Grand Prix: gli studenti di ITIS, ITS Academy e Università d'Italia e del mondo si sfidano sui veicoli elettrici ad alta efficienza.\n\nPer le aziende Automotive ed Energy è l'occasione di:\n→ Talent Acquisition: incontrare nei box i giovani esperti STEM del domani\n→ Visibilità media: pista, paddock, canali evento e stampa\n→ CSR: sostenere concretamente la transizione ecologica della formazione tecnica\n\nLe candidature Sponsor — Platinum Host, Gold, Silver, Bronze — sono aperte.\n👉 Scriveteci per ricevere il media pack.\n\n#EVGPItalia2027 #MotorValley #STEM #MobilitàElettrica #CSR",
            en: "⚡ EVGP Italia 2027 | Motor Valley is looking for its partners\n\nFrom 3 to 9 May 2027, Misano World Circuit \"Marco Simoncelli\" will host the Electric Vehicle Grand Prix: students from ITIS, ITS Academy and universities across Italy and the world will compete in high-efficiency electric vehicles.\n\nFor Automotive and Energy companies this is the chance to:\n→ Talent acquisition: meet tomorrow's STEM experts in the garages\n→ Media visibility: track, paddock, event channels and press\n→ CSR: tangibly support the green transition of technical education\n\nSponsor applications — Platinum Host, Gold, Silver, Bronze — are now open.\n👉 Contact us to receive the media pack.\n\n#EVGPItalia2027 #MotorValley #STEM #ElectricMobility #CSR",
          },
        },
        {
          id: "instagram",
          label: "Instagram",
          audience: { it: "Per ingaggiare gli studenti", en: "To engage students" },
          text: {
            it: "POV: sei in box a Misano e il tuo prototipo è pronto ⚡🏁\n\n3 ruote. 1.0 kWh. Una settimana di gara.\nDal 3 al 9 maggio 2027 le scuole di tutta Italia si sfidano al Misano World Circuit: chi farà il giro più efficiente con un solo kWh?\n\nTi riconosci in questo team? Tagga il tuo istituto nei commenti 👇\n\n#RoadToMisano #EVGPItalia2027 #StudentiInPista #STEM",
            en: "POV: you're in the garage at Misano and your prototype is ready ⚡🏁\n\n3 wheels. 1.0 kWh. One race week.\nFrom 3 to 9 May 2027, schools from all over Italy will battle it out at Misano World Circuit: who sets the most efficient lap on a single kWh?\n\nIs this your team? Tag your school in the comments 👇\n\n#RoadToMisano #EVGPItalia2027 #STEM #ElectricRacing",
          },
        },
        {
          id: "tiktok",
          label: "TikTok",
          audience: { it: "Per ingaggiare gli studenti", en: "To engage students" },
          text: {
            it: "Il tuo istituto può costruire questa macchina ⚡\n\n3 ruote, 1.0 kWh e una settimana di gara al Misano World Circuit (3-9 maggio 2027).\nProgetti in classe, costruisci in officina e gareggi con il tuo team: lo STEM che si vede in pista.\n\nQual è la materia che serve di più per costruire una EV? Rispondi nei commenti 👇\n\n#RoadToMisano #EVGPItalia2027 #STEM #StudentiInPista",
            en: "Your school could build this car ⚡\n\n3 wheels, 1.0 kWh and a full race week at Misano World Circuit (3-9 May 2027).\nDesign it in class, build it in the workshop, race it with your team: STEM you can see on track.\n\nWhich subject matters most to build an EV? Drop it in the comments 👇\n\n#RoadToMisano #EVGPItalia2027 #STEM #StudentRacing",
          },
        },
        {
          id: "facebook",
          label: "Facebook",
          audience: { it: "Per le scuole e le famiglie", en: "For schools and families" },
          text: {
            it: "🏫 Scuole di Romagna e di tutta Italia: si apre la settimana dell'EVGP Italia 2027!\n\nDal 3 al 9 maggio 2027 il Circuito Misanino — Misano World Circuit ospita i vostri studenti con due modalità di partecipazione:\n\nA) TEAM IN PISTA — costruite la monoposto elettrica con il kit ufficiale, con supporto PNRR STEM e strategie di crowdfunding\nB) DELEGAZIONE ESPERIENZIALE — forum tecnici serali, network con aziende e università, vita di box\n\nUn'esperienza STEM unica tra scuola, territorio e futuro della mobilità elettrica.\n📩 Richiedete la scheda di adesione: info@evgpitalia.it\n\n#EVGPItalia2027 #ScuoleInPista #STEM #Misano",
            en: "🏫 Schools of Romagna and all of Italy: the EVGP Italia 2027 week is opening up!\n\nFrom 3 to 9 May 2027 the Circuito Misanino — Misano World Circuit will host your students with two modes of participation:\n\nA) TEAM ON TRACK — build your electric single seater with the official kit, supported by STEM funding (PNRR) and crowdfunding strategies\nB) EXPERIENTIAL DELEGATION — evening technical forums, networking with companies and universities, garage life\n\nA unique STEM experience blending school, local area and the future of electric mobility.\n📩 Request the entry form: info@evgpitalia.it\n\n#EVGPItalia2027 #SchoolsOnTrack #STEM #Misano",
          },
        },
      ],
    },
    sponsor: {
      kicker: "Sponsor & Partner",
      title: "Entra nel Motor Valley Network",
      en: "Platinum Host · Gold · Silver · Bronze",
      values: [
        { title: "Talent Acquisition STEM", desc: "Incontra nei box i giovani esperti STEM che domani progetteranno la tua industria." },
        { title: "Visibilità media", desc: "Pista, paddock, canali evento e stampa: il tuo marchio al centro della race week." },
        { title: "CSR & Transizione Ecologica", desc: "Sostieni concretamente la formazione tecnica verde e la mobilità sostenibile." },
      ],
      platinumEyebrow: "Tier 01 — Main Sponsor",
      platinumTitle: "Platinum Host",
      platinumDesc: "Il partner istituzionale dell'evento: naming nei materiali ufficiali, presenza totale su pista, paddock, scena premiazione e campagna social EVGP.",
      platinumSlots: ["Il tuo marchio", "Host istituzionale", "Naming ufficiale", "Premiazione"],
      tierLabel: (i) => `Tier 0${i + 2}`,
      tierSponsor: " Sponsor",
      yourLogo: "Il tuo marchio qui",
      form: {
        title: "Diventa Sponsor",
        intro: "Lascia la tua richiesta: riceverai il media pack con inventory, formati e pacchetti personalizzati.",
        azienda: "Azienda *",
        referente: "Referente *",
        email: "Email aziendale *",
        telefono: "Telefono",
        messaggio: "Messaggio",
        submit: "Invia la richiesta di partenariato",
        sending: "Invio in corso...",
        error: "Compila i campi obbligatori: azienda, referente ed email.",
        successTitle: "Richiesta ricevuta!",
        success: "Abbiamo registrato la richiesta di partenariato: riceverai il media pack all'indirizzo indicato.",
        reset: "Invia un'altra richiesta",
      },
      ctaText: "Le candidature per la race week 3—9 maggio 2027 sono aperte: richiedi il media pack con inventory, formati e pacchetti personalizzati.",
      ctaButton: "Diventa Sponsor",
    },
    logistica: {
      kicker: "Logistica & Accrediti",
      title: "Arrivare a Misano è facile",
      en: "Circuito · hotel · navette aeree",
      items: [
        { title: "Il Circuito", desc: "Circuito Misanino — Misano World Circuit «Marco Simoncelli», nel cuore della Motor Valley romagnola a Misano Adriatico (RN)." },
        { title: "Hotel & B&B", desc: "Convenzioni riservate con gli hotel e i B&B della Riviera Romagnola per team, docenti e delegazioni." },
        { title: "Navette aeroportuali", desc: "Servizio navette dedicato da e per gli aeroporti di Bologna (BLQ), Forlì (FRL) e Rimini (RMI)." },
        { title: "Accrediti", desc: "Accrediti team e delegazioni con ritiro in paddock il giorno di arrivo: kit, badge e materiali ufficiali EVGP." },
      ],
      stripTitle: "Navette aeroportuali EVGP",
      imgTitle: "Misano World Circuit",
      imgSub: "«Marco Simoncelli» — Misano Adriatico (RN)",
    },
    footer: {
      claim: "La Motor Valley incontra il futuro della mobilità elettrica: una settimana di STEM, pista e crescita per le scuole d'Italia e del mondo.",
      kicker: "Where Motor Valley meets the electric future",
      sections: "Sezioni",
      contacts: "Contatti",
      pdfTitle: "Moduli di adesione (PDF)",
      pdfLinks: [
        { label: "Adesione Scuole & ITS", href: "/api/scheda-adesione", tid: "footer-pdf-scuole" },
        { label: "Partenariato Sponsor", href: "/api/scheda-partenariato", tid: "footer-pdf-sponsor" },
        { label: "Istituzioni & Enti", href: "/api/scheda-istituzioni", tid: "footer-pdf-istituzioni" },
      ],
      promoter: "Ente Promotore",
      promoterName: "Global EEE",
      promoterSub: "Education · Energy · Environment",
      copyright: "© 2027 EVGP Italia 2027 — Organizzato da Co.Ge.S.Tur. Soc. Coop.",
      promoted: "Promosso da Global EEE",
      links: [
        { id: "progetto", label: "Progetto & Missione" },
        { id: "programma", label: "Programma" },
        { id: "scuole", label: "Scuole & ITS" },
        { id: "social", label: "Piano Social" },
        { id: "sponsor", label: "Sponsor" },
        { id: "logistica", label: "Logistica" },
      ],
    },
  },

  en: {
    nav: {
      links: [
        { id: "progetto", label: "Project" },
        { id: "programma", label: "Programme" },
        { id: "scuole", label: "Schools & ITS" },
        { id: "social", label: "Social Plan" },
        { id: "sponsor", label: "Sponsors" },
        { id: "logistica", label: "Logistics" },
      ],
      cta: "Join the Event",
    },
    hero: {
      chip1: "Misano World Circuit — 3/9 May 2027",
      chip2: "Electric Vehicle Grand Prix",
      lines: [
        { t: "Motor Valley meets", g: null },
        { t: "the future of", g: null },
        { t: "", g: "Electric Mobility." },
      ],
      sub: "From 3 to 9 May 2027 at the Misano Circuit: students from schools and universities across Italy and the world compete in high-efficiency electric vehicles.",
      kicker: "La Motor Valley incontra il futuro della mobilità elettrica",
      cta1: "Get the Entry Form",
      cta2: "Become a Sponsor",
      countdown: [
        { l: "Days", tid: "countdown-days" },
        { l: "Hours", tid: "countdown-hours" },
        { l: "Min", tid: "countdown-minutes" },
        { l: "Sec", tid: "countdown-seconds" },
      ],
      imgChips: { soc: "1.0 kWh battery SOC", telemetry: "Telemetry active", limiter: "Speed limiter on" },
      imgCaption: "EV-01 · 3-wheel single seater",
      imgTag: "Official EVGP kit",
    },
    marquee: ["EVGP Italia 2027", "3—9 May", "Misano World Circuit", "Design", "Build", "Race", "Grow"],
    progetto: {
      kicker: "The Project & Mission",
      title: "Design. Build. Race. Grow.",
      en: "Il format — lo STEM incontra la pista",
      pillars: [
        { t: "Design", d: "From aerodynamics to energy management: teams design their single seater in class with the support of teachers and technical partners." },
        { t: "Build", d: "The official EVGP kit takes shape in school workshops: chassis, wiring and battery pack assembled by the students." },
        { t: "Race", d: "On track at Misano with live telemetry: every overtaking move is a lesson in applied physics and energy efficiency." },
        { t: "Grow", d: "Technical forums, company networking and STEM skills that teams keep long after the finish line." },
      ],
      specEyebrow: "EV-01 — Technical Sheet",
      specTitle: "Vehicle Technical Sheet",
      specs: [
        { label: "Type", value: "High-efficiency 3-wheel single seater" },
        { label: "Energy", value: "Lead-acid batteries · 1.0 kWh with monitoring" },
        { label: "Telemetry", value: "Cycle Analyst · real-time data logging" },
        { label: "Safety", value: "Speed limitation for maximum safety" },
      ],
      chips: ["1.0 kWh", "Cycle Analyst", "3 Wheels"],
      imgCaption: "Build — the school workshop",
      cockpitCaption: "Cycle Analyst · Data log",
    },
    programma: {
      kicker: "Event Programme",
      title: "Seven days on track: 3—9 May 2027",
      en: "La settimana di gara — giorno per giorno",
      mayLabel: "May 2027",
      days: [
        { d: "3", wd: "Mon", phase: "Kit & Team Arrival", tag: "Paddock", desc: "Delivery of the official EVGP kits, team accreditations and paddock opening: schools take over their garages at the Misano circuit." },
        { d: "4", wd: "Tue", phase: "Garage Set-up", tag: "Paddock", desc: "Building workstations, setting up tools and the data bench: the paddock turns into an open-air workshop." },
        { d: "5", wd: "Wed", phase: "Technical Scrutineering", tag: "Scrutineering", desc: "Officials check vehicle compliance: chassis, batteries, wiring and safety systems before going on track." },
        { d: "6", wd: "Thu", phase: "Free Practice", tag: "Track", desc: "First laps with Cycle Analyst telemetry live: shake-down runs and fine-tuning of the settings." },
        { d: "7", wd: "Fri", phase: "Free Practice & Evening Tech Forums", tag: "Track · Forums", desc: "Driving sessions by day and, at sunset, technical forums with engineers and partner companies: energy, aerodynamics, strategy." },
        { d: "8", wd: "Sat", phase: "Qualifying & EVGP RACE", tag: "Race", desc: "Qualifying sets the starting grid: in the afternoon the EVGP Italia 2027 RACE crowns the winners on the Misano circuit.", hot: true },
        { d: "9", wd: "Sun", phase: "Awards Gala & Pack-down", tag: "Gala", desc: "The week closes with the teams' awards gala and the paddock pack-down: see you in 2028." },
      ],
    },
    scuole: {
      kicker: "Schools & ITS Area",
      title: "Two ways to live the EVGP",
      en: "Two ways to take part — teams on track or experiential delegations",
      optionA: {
        title: "Team on Track",
        desc: "Official kit supply and STEM national-plan (PNRR) support: your school designs and builds its own single seater, with crowdfunding strategies included to fund the project all the way to the race.",
        tag: "Request the EVGP Kit",
      },
      optionB: {
        title: "Experiential Delegation",
        desc: "Evening technical forums, inclusion, networking with companies and universities, and full garage life: the complete EVGP experience without building the vehicle, immersed in Motor Valley.",
        tag: "Join with your class",
      },
      formTitle: "Entry Form",
      formIntro: "Fill in the request: the Co.Ge.S.Tur. organising team will get back to you with kits, costs and support for your chosen mode of participation.",
      formTag: "ITIS · IPSIA · ITS Academy · University",
      imgCaption: "A single seater from a participating school",
      modeLabel: "Mode of participation *",
      modes: [
        { v: "team_in_pista", l: "A — Team on Track (EVGP Kit)" },
        { v: "delegazione", l: "B — Experiential Delegation" },
      ],
      fields: {
        nome: "Contact teacher full name *",
        istituto: "School / ITS / University *",
        email: "Institutional email *",
        telefono: "Phone",
        num_studenti: "Students involved",
        messaggio: "Message",
      },
      roleOptions: ["Teacher / Coordinator", "Head of School", "Student", "ITS / University Rep.", "Other"],
      roleLabel: "Role",
      msgPlaceholder: "Tell us about your school, the team's experience, questions about the kit...",
      error: "Please fill in the required fields: name, school and email.",
      sending: "Sending...",
      submit: "Send your entry request",
      successTitle: "Request received!",
      success: (nome, istituto, email) => `Thanks ${nome}: we've registered the request for ${istituto}. You'll receive the full entry form at ${email}.`,
      reset: "Send another request",
    },
    social: {
      kicker: "Social Media Plan & Content",
      title: "#RoadToMisano — the event's social strategy",
      en: "Architettura dei canali · calendario editoriale · copy pronti",
      bannerTag: "#MeetTheTeam",
      bannerTitle: "EVGP teams at work",
      channels: [
        { name: "LinkedIn", audience: "B2B & Institutions", desc: "Principals, universities, sponsors and ministries: event preparation, the STEM value of the format, partnerships and team results." },
        { name: "Instagram / TikTok", audience: "Students & Youth", desc: "Behind the scenes from the garages, dynamic reels of the prototypes on track, team vlogs throughout race week." },
        { name: "Facebook", audience: "Community & Families", desc: "Local community, families and institutional updates: programme, logistics and public initiatives." },
      ],
      calTitle: "Editorial calendar — 4 core formats",
      formats: [
        { tag: "#TechTuesday", cadence: "Every Tuesday", desc: "Technical kit details: batteries, controllers, aerodynamics." },
        { tag: "#MeetTheTeam", cadence: "Every Thursday", desc: "Introducing the participating schools and ITS Academies." },
        { tag: "#RoadToMisano", cadence: "Weekly", desc: "Countdown and event logistics: what to see and how to get there." },
        { tag: "#EVGPSocial", cadence: "Weekend", desc: "Focus on inclusion, evening forums and team life." },
      ],
      copyTitle: "Ready-to-use copywriting",
      copySub: "Posts ready to publish",
      bioCopied: "Bio copied to clipboard",
      postCopied: "Post copied to clipboard",
      copyFailed: "Copy failed",
      copied: "Copied!",
      copyPost: "Copy post",
      setupTitle: "Channel setup",
      setupSub: "Names, handles and bios ready to open the pages",
      handleLabel: "Suggested handle",
      channelsSetup: [
        { name: "Facebook", handle: "facebook.com/evgpitalia", bioIt: "Il Grand Prix dei veicoli elettrici costruiti dagli studenti. 3-9 maggio 2027 · Misano World Circuit. Progettare, Costruire, Gareggiare, Crescere ⚡", bioEn: "The Grand Prix of student-built electric vehicles. 3-9 May 2027 · Misano World Circuit. Design, Build, Race, Grow ⚡" },
        { name: "Instagram", handle: "@evgpitalia", bioIt: "⚡ Studenti in pista con le monoposto elettriche | 3-9 MAGGIO 2027 · MWC Misano | #RoadToMisano", bioEn: "⚡ Students on track with electric racers | 3-9 MAY 2027 · MWC Misano | #RoadToMisano" },
        { name: "TikTok", handle: "@evgpitalia", bioIt: "STEM in pista ⚡ Le monoposto elettriche degli studenti d'Italia | 3-9 maggio 2027 Misano", bioEn: "STEM on track ⚡ Student-built EV racers from Italy | May 3-9, 2027 Misano" },
      ],
      posts: [
        {
          id: "linkedin",
          label: "LinkedIn",
          audience: { it: "Per ingaggiare gli sponsor", en: "To engage sponsors" },
          text: {
            it: "⚡ EVGP Italia 2027 | La Motor Valley cerca i suoi partner\n\nDal 3 al 9 maggio 2027 il Misano World Circuit «Marco Simoncelli» ospita l'Electric Vehicle Grand Prix: gli studenti di ITIS, ITS Academy e Università d'Italia e del mondo si sfidano sui veicoli elettrici ad alta efficienza.\n\nPer le aziende Automotive ed Energy è l'occasione di:\n→ Talent Acquisition: incontrare nei box i giovani esperti STEM del domani\n→ Visibilità media: pista, paddock, canali evento e stampa\n→ CSR: sostenere concretamente la transizione ecologica della formazione tecnica\n\nLe candidature Sponsor — Platinum Host, Gold, Silver, Bronze — sono aperte.\n👉 Scriveteci per ricevere il media pack.\n\n#EVGPItalia2027 #MotorValley #STEM #MobilitàElettrica #CSR",
            en: "⚡ EVGP Italia 2027 | Motor Valley is looking for its partners\n\nFrom 3 to 9 May 2027, Misano World Circuit \"Marco Simoncelli\" will host the Electric Vehicle Grand Prix: students from ITIS, ITS Academy and universities across Italy and the world will compete in high-efficiency electric vehicles.\n\nFor Automotive and Energy companies this is the chance to:\n→ Talent acquisition: meet tomorrow's STEM experts in the garages\n→ Media visibility: track, paddock, event channels and press\n→ CSR: tangibly support the green transition of technical education\n\nSponsor applications — Platinum Host, Gold, Silver, Bronze — are now open.\n👉 Contact us to receive the media pack.\n\n#EVGPItalia2027 #MotorValley #STEM #ElectricMobility #CSR",
          },
        },
        {
          id: "instagram",
          label: "Instagram",
          audience: { it: "Per ingaggiare gli studenti", en: "To engage students" },
          text: {
            it: "POV: sei in box a Misano e il tuo prototipo è pronto ⚡🏁\n\n3 ruote. 1.0 kWh. Una settimana di gara.\nDal 3 al 9 maggio 2027 le scuole di tutta Italia si sfidano al Misano World Circuit: chi farà il giro più efficiente con un solo kWh?\n\nTi riconosci in questo team? Tagga il tuo istituto nei commenti 👇\n\n#RoadToMisano #EVGPItalia2027 #StudentiInPista #STEM",
            en: "POV: you're in the garage at Misano and your prototype is ready ⚡🏁\n\n3 wheels. 1.0 kWh. One race week.\nFrom 3 to 9 May 2027, schools from all over Italy will battle it out at Misano World Circuit: who sets the most efficient lap on a single kWh?\n\nIs this your team? Tag your school in the comments 👇\n\n#RoadToMisano #EVGPItalia2027 #STEM #ElectricRacing",
          },
        },
        {
          id: "tiktok",
          label: "TikTok",
          audience: { it: "Per ingaggiare gli studenti", en: "To engage students" },
          text: {
            it: "Il tuo istituto può costruire questa macchina ⚡\n\n3 ruote, 1.0 kWh e una settimana di gara al Misano World Circuit (3-9 maggio 2027).\nProgetti in classe, costruisci in officina e gareggi con il tuo team: lo STEM che si vede in pista.\n\nQual è la materia che serve di più per costruire una EV? Rispondi nei commenti 👇\n\n#RoadToMisano #EVGPItalia2027 #STEM #StudentiInPista",
            en: "Your school could build this car ⚡\n\n3 wheels, 1.0 kWh and a full race week at Misano World Circuit (3-9 May 2027).\nDesign it in class, build it in the workshop, race it with your team: STEM you can see on track.\n\nWhich subject matters most to build an EV? Drop it in the comments 👇\n\n#RoadToMisano #EVGPItalia2027 #STEM #StudentRacing",
          },
        },
        {
          id: "facebook",
          label: "Facebook",
          audience: { it: "Per le scuole e le famiglie", en: "For schools and families" },
          text: {
            it: "🏫 Scuole di Romagna e di tutta Italia: si apre la settimana dell'EVGP Italia 2027!\n\nDal 3 al 9 maggio 2027 il Circuito Misanino — Misano World Circuit ospita i vostri studenti con due modalità di partecipazione:\n\nA) TEAM IN PISTA — costruite la monoposto elettrica con il kit ufficiale, con supporto PNRR STEM e strategie di crowdfunding\nB) DELEGAZIONE ESPERIENZIALE — forum tecnici serali, network con aziende e università, vita di box\n\nUn'esperienza STEM unica tra scuola, territorio e futuro della mobilità elettrica.\n📩 Richiedete la scheda di adesione: info@evgpitalia.it\n\n#EVGPItalia2027 #ScuoleInPista #STEM #Misano",
            en: "🏫 Schools of Romagna and all of Italy: the EVGP Italia 2027 week is opening up!\n\nFrom 3 to 9 May 2027 the Circuito Misanino — Misano World Circuit will host your students with two modes of participation:\n\nA) TEAM ON TRACK — build your electric single seater with the official kit, supported by STEM funding (PNRR) and crowdfunding strategies\nB) EXPERIENTIAL DELEGATION — evening technical forums, networking with companies and universities, garage life\n\nA unique STEM experience blending school, local area and the future of electric mobility.\n📩 Request the entry form: info@evgpitalia.it\n\n#EVGPItalia2027 #SchoolsOnTrack #STEM #Misano",
          },
        },
      ],
    },
    sponsor: {
      kicker: "Sponsors & Partners",
      title: "Join the Motor Valley Network",
      en: "Platinum Host · Gold · Silver · Bronze",
      values: [
        { title: "STEM Talent Acquisition", desc: "Meet in the garages the young STEM experts who will design your industry tomorrow." },
        { title: "Media visibility", desc: "Track, paddock, event channels and press: your brand at the centre of race week." },
        { title: "CSR & Green Transition", desc: "Tangibly support green technical education and sustainable mobility." },
      ],
      platinumEyebrow: "Tier 01 — Main Sponsor",
      platinumTitle: "Platinum Host",
      platinumDesc: "The event's institutional partner: naming across official materials, total presence on track, paddock, awards stage and the EVGP social campaign.",
      platinumSlots: ["Your brand", "Institutional host", "Official naming", "Award stage"],
      tierLabel: (i) => `Tier 0${i + 2}`,
      tierSponsor: " Sponsor",
      yourLogo: "Your logo here",
      form: {
        title: "Become a Sponsor",
        intro: "Leave your request: you'll receive the media pack with inventory, formats and tailor-made packages.",
        azienda: "Company *",
        referente: "Contact person *",
        email: "Company email *",
        telefono: "Phone",
        messaggio: "Message",
        submit: "Send your partnership request",
        sending: "Sending...",
        error: "Please fill in the required fields: company, contact person and email.",
        successTitle: "Request received!",
        success: "Your partnership request has been registered: you'll receive the media pack at the address provided.",
        reset: "Send another request",
      },
      ctaText: "Applications for race week 3—9 May 2027 are open: request the media pack with inventory, formats and tailor-made packages.",
      ctaButton: "Become a Sponsor",
    },
    logistica: {
      kicker: "Logistics & Accreditations",
      title: "Getting to Misano is easy",
      en: "Circuito · hotel · navette aeree",
      items: [
        { title: "The Circuit", desc: "Circuito Misanino — Misano World Circuit \"Marco Simoncelli\", in the heart of the Romagna Motor Valley in Misano Adriatico (RN)." },
        { title: "Hotels & B&Bs", desc: "Reserved rates with Riviera Romagnola hotels and B&Bs for teams, teachers and delegations." },
        { title: "Airport shuttles", desc: "Dedicated shuttle service to and from Bologna (BLQ), Forlì (FRL) and Rimini (RMI) airports." },
        { title: "Accreditations", desc: "Team and delegation accreditations collected in the paddock on arrival day: kit, badges and official EVGP materials." },
      ],
      stripTitle: "EVGP Airport Shuttles",
      imgTitle: "Misano World Circuit",
      imgSub: "\"Marco Simoncelli\" — Misano Adriatico (RN)",
    },
    footer: {
      claim: "Motor Valley meets the future of electric mobility: a week of STEM, track and growth for schools from Italy and around the world.",
      kicker: "La Motor Valley incontra il futuro della mobilità elettrica",
      sections: "Sections",
      contacts: "Contacts",
      pdfTitle: "Entry forms (PDF)",
      pdfLinks: [
        { label: "Schools & ITS entry", href: "/api/scheda-adesione", tid: "footer-pdf-scuole" },
        { label: "Sponsor partnership", href: "/api/scheda-partenariato", tid: "footer-pdf-sponsor" },
        { label: "Institutions & bodies", href: "/api/scheda-istituzioni", tid: "footer-pdf-istituzioni" },
      ],
      promoter: "Promoting Body",
      promoterName: "Global EEE",
      promoterSub: "Education · Energy · Environment",
      copyright: "© 2027 EVGP Italia 2027 — Organised by Co.Ge.S.Tur. Soc. Coop.",
      promoted: "Promoted by Global EEE",
      links: [
        { id: "progetto", label: "Project & Mission" },
        { id: "programma", label: "Programme" },
        { id: "scuole", label: "Schools & ITS" },
        { id: "social", label: "Social Plan" },
        { id: "sponsor", label: "Sponsors" },
        { id: "logistica", label: "Logistics" },
      ],
    },
  },
};
